// Cores dos balões das Mensagens (0.38). A cor própria do My Planner: violeta para o que você manda e grafite
// (ou lilás claro, no modo claro) para o que você recebe. Cada pessoa pode trocar em Mensagens > Cores das conversas.
import { useDoc } from '../store/store';
import { modoDoApp } from '../components/theme';

export const ENVIADA_PADRAO = '#7048E8';
export const recebidaPadrao = () => (modoDoApp() === 'claro' ? '#EDE9FE' : '#262A36');

export const OPCOES_ENVIADA = ['#7048E8', '#C2410C', '#0F766E', '#BE185D', '#1D4ED8', '#4D7C0F', '#B45309', '#6D28D9', '#0E7490', '#374151'];
export const OPCOES_RECEBIDA = ['', '#111827', '#2E2440', '#1F3533', '#3A2C1F', '#22304A', '#EDE9FE', '#F1F5F9', '#FEF3C7', '#DCFCE7'];

/** Texto branco ou escuro, o que ler melhor sobre a cor. */
export function textoSobre(hex: string) {
  const h = hex.replace('#', '');
  const [r, g, b] = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16) / 255).map(v => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
  const l = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return l > 0.4 ? '#111827' : '#FFFFFF';
}

export function useCoresChat() {
  const aj = useDoc('ajustes');
  const enviada = aj?.chatCores?.enviada || ENVIADA_PADRAO;
  const recebida = aj?.chatCores?.recebida || recebidaPadrao();
  const te = textoSobre(enviada), tr = textoSobre(recebida);
  return { enviada, recebida, textoEnviada: te, textoRecebida: tr,
    suaveEnviada: te === '#FFFFFF' ? 'rgba(255,255,255,0.75)' : 'rgba(17,24,39,0.6)',
    suaveRecebida: tr === '#FFFFFF' ? 'rgba(255,255,255,0.6)' : 'rgba(17,24,39,0.55)' };
}
